export const getVariableCss = (variable) => window.getComputedStyle(document.documentElement)
    .getPropertyValue(`--${variable}`);

